import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ICountryDtoModel } from "../models/country/country-dto.model";
import { IProductCountryDtoModel, IProductCountryDtoModels } from "../models/country/product-country-dto.model";
import { EnvironmentService } from "./environment.service";
@Injectable({
    providedIn: 'root'
  })
export class CountryService {
    constructor(private httpClient: HttpClient,
        public envService: EnvironmentService) {
    }
    public getOptions(): Observable<IProductCountryDtoModels> {
        throw new Error("Method not implemented.");
        //return this.httpClient.get<IProductCountryDtoModels>(`https://app-api-sngbarratt-customermanagement-dev.azurewebsites.net/api/Options/countries`); //todo - use env file
    }
}